import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { LocationTrackingScheduleSearch } from './LocationTrackingScheduleSearch';
import { LocationTrackingScheduleDisplay } from './LocationTrackingScheduleDisplay';
import { LocationTrackingScheduleCreate } from './LocationTrackingScheduleCreate';
import { LocationTrackingScheduleUpdate } from './LocationTrackingScheduleUpdate';

/**
 * Location Tracking Schedule Routes
 *
 * Routing for location tracking schedule management pages
 */
export const LocationTrackingScheduleRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/create" element={<LocationTrackingScheduleCreate />} />
    <Route path="/display/:key" element={<LocationTrackingScheduleDisplay />} />
    <Route path="/search" element={<LocationTrackingScheduleSearch />} />
    <Route path="/update/:key" element={<LocationTrackingScheduleUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
